import React from "react";

import { Switch } from "@mui/material";

type PropsType = {
    checked: boolean;
    onChange?: (value: boolean) => void;
    setValue?: (path: string, value: any) => void;
    path?: string;
    label?: string;
    disabled?: boolean;
    horizontal?: boolean;
    withoutPadding?: boolean;
    alignedToForm?: boolean;
};

function SwitchInput({
    checked,
    onChange,
    setValue,
    path,
    label,
    disabled,
    horizontal = false,
    withoutPadding = false,
    alignedToForm = false,
}: PropsType) {
    const onChangeCalculated = React.useCallback(
        (event) => {
            if (onChange) {
                onChange(event.target.checked);
            }

            if (setValue && path) {
                setValue(path, event.target.checked);
            }
        },
        [onChange, setValue, path]
    );

    return (
        <div
            className={`input switch-container 
                ${withoutPadding ? "without-padding" : ""} 
                ${alignedToForm ? "aligned-to-form" : ""} 
                ${horizontal ? "horizontal" : ""}`}
        >
            {!horizontal && label && <label>{label}</label>}
            <Switch checked={checked} onChange={onChangeCalculated} disabled={disabled} />
            {horizontal && label && <label>{label}</label>}
        </div>
    );
}

export default SwitchInput;
